import React from "react";
import "./VideoPlayer.scss";
import { uiActions } from "../../store/ui-slice";
import { useSelector, useDispatch } from "react-redux";

const VideoPlayer = () => {

	const dispatch = useDispatch();
	const contactOpened = useSelector((state) => state.ui.videoURL);
	if ( contactOpened ) {
		return (
			<div className="popup" id="videoPopup">
				<div className="popup-content">
					<div className={'responsive-video'}>
						<iframe src={contactOpened} allow={'autoplay'}></iframe>
						<button className="menu-button" id="closePopupBtn" onClick={() => {
							dispatch(uiActions.openVideo(''))
						}}>
			                    <span></span>
			                    <span></span>
			                    <span></span>
						</button>
					</div>
				</div>
			</div>

		);
	}
	return (
		<div></div>
	)
};

export default VideoPlayer;
